import EnrouteApiClient from '../../shared/services/enroute-api-client';
import { ServerError, ServerErrorMessages } from '../../shared/utils/server-error-utils';
import { InsightsData, InsightsParams } from '../../shared/models/insights';


const postProccess = (task) => {
  return {
    ...task,
    feedback_rating: +task.feedback_rating < 0 ? 0 : +task.feedback_rating,
    time_arrived: +task.time_arrived,
    completed_time: +task.completed_time,
    due_time: +task.due_time,
  };
};

export default class InsightsService {

  public static async getTasksDetails({ orgId, selectedDrivers, startDate, endDate}: InsightsParams): Promise<InsightsData | Error> {

    return EnrouteApiClient.get(`/edwreport/${ orgId }/tasks_details?org_id=${orgId}&completed_from=${startDate.getTime()}&completed_to=${endDate.getTime()}`)
      .then((resp) => {
        const { tasks = [] } = resp.data; // mapAxiosResponse<any>(resp);
        return {
          tasks: (!selectedDrivers?.length ? tasks : tasks?.filter(value => selectedDrivers.indexOf(+ value.agent_id) !== -1)).map(task => postProccess(task)),
          orgId,
          startDate,
          endDate,
          selectedDrivers
        };
      })
      .catch(error => {
        let errorMessage = ServerErrorMessages[error.message];
        if (!errorMessage) {
          errorMessage = ServerErrorMessages[ServerError.UnexpectedError];
        }

        throw new Error(errorMessage);
      });
  }
}
